import React from "react";
import BounceLoader from "react-spinners/BounceLoader";
import { makeStyles } from "@material-ui/core";
const useStyle = makeStyles((theme) => {
  return {
    container: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    text: {
      margin: theme.spacing(1, 0, 0),
      fontSize: 14,
      color: "rgba(226, 19, 110, 1)",
      fontWeight: 600,
    },
    subtext: {
      margin: theme.spacing(0),
      fontSize: 12,
      color: "rgba(226, 19, 110, 1)",
      fontWeight: 500,
    },
  };
});

export default function Loading() {
  const classes = useStyle();
  return (
    <div className={classes.container}>
      <BounceLoader />
      <p className={classes.text}>Loading data...</p>
      <p className={classes.subtext}>Please wait...</p>
    </div>
  );
}
